import { render, staticRenderFns } from "./app-password.vue?vue&type=template&id=8034c2dc&scoped=true&"
import script from "./app-password.vue?vue&type=script&lang=ts&"
export * from "./app-password.vue?vue&type=script&lang=ts&"
import style0 from "./app-password.vue?vue&type=style&index=0&id=8034c2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8034c2dc",
  null
  
)

export default component.exports